"use client";

import React from "react";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonRefresher,
  IonRefresherContent,
  useIonViewWillEnter,
} from "@ionic/react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  Button,
  Card,
  CardContent,
  Grid,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  Divider,
  Alert,
  CircularProgress,
  Tooltip,
  TablePagination,
  Collapse,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import {
  Search,
  FilterList,
  Download,
  Visibility,
  Close,
  AttachMoney,
  Receipt,
  Person,
  ExpandMore,
  ExpandLess,
  CheckCircle,
  Warning,
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers";
import {
  getCashierOrders,
  getCashierOrders_reciept,
  getCashierOrders_reciept_date,
  getContraData,
} from "../../../api/orders/orders";
import { formatCurrencyN } from "../../../common/utils_t";
import { green } from "@mui/material/colors"; // import MUI green palette
import { MenuButton } from "../../../components/Menu";

interface OrderItem {
  product_id: string;
  quantity: string;
  product_name: string;
  price: string;
  total_amount: string;
  item_status: string;
}

interface SalesTransaction {
  order_id: string;
  order_code: string;
  order_date: string;
  mode_of_payment: string;
  payable_amount: string;
  balance_due: string;
  order_by: string;
  order_status: string;
  member_id: string;
  member_name: string;
  payment_status: string;
  otp_status: string | null;
  items: OrderItem[];
  amount_paid: string;
}

interface SalesStats {
  total_sales: number;
  total_orders: number;
  average_order_value: number;
  top_payment_method: string;
  growth_percentage: number;
  pending_orders: number;
  completed_orders: number;
}

interface FilterState {
  startDate: Date | null;
  endDate: Date | null;
  paymentMethod: string;
  department: string;
  orderStatus: string;
  paymentStatus: string;
}

const SalesRecieptPage_Ex: React.FC = () => {
  const [transactions, setTransactions] = useState<SalesTransaction[]>([]);
  const [filteredTransactions, setFilteredTransactions] = useState<
    SalesTransaction[]
  >([]);
  const [salesStats, setSalesStats] = useState<SalesStats | null>(null);
  const [loading, setLoading] = useState(false);
  const [loading_real, setloading_real] = useState(false);

  
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [showTransactionDetail, setShowTransactionDetail] = useState(false);
  const [selectedTransaction, setSelectedTransaction] =
    useState<SalesTransaction | null>(null);
  const [expandedRows, setExpandedRows] = useState<string[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [filters, setFilters] = useState<FilterState>({
    startDate: dayjs(), // today
    endDate: dayjs(),
    paymentMethod: "",
    department: "",
    orderStatus: "",
    paymentStatus: "",
  });

  const paymentMethods = ["All", "manual_payment", "auto_payment"];
  const orderStatuses = ["All", "COMPLETED", "PENDING", "CANCELLED"];
  const paymentStatuses = ["All", "0", "1", "2"]; // 0=unpaid, 1=paid, 2=partial
  const departments = [
    "All",
    "Food & Beverage",
    "Electronics",
    "Clothing",
    "Books",
  ];

  useEffect(() => {
    fetchSalesData();
    fetchContraData();
  }, [filters]);

  useEffect(() => {
    applyFilters();
  }, [transactions, searchQuery]);
  const [contra, setContra] = useState<[]>([]);

  const fetchContraData = async () => {
    try {
      // Simulate API call
      const response = await getContraData();
      // const response = { data: mockTransactions }
      console.log({ response });

      // Fetch staff data
      // await fetchStaffData()

      setContra(response.data);

      // Calculate stats from actual data
    } catch (error) {
      console.error("Error fetching contra data:", error);
    } finally {
      setLoading(false);
    }
  };
  const [myBalance_due, setMyBalance_due] = useState("0");
  const [myAmount_paid, setMyAmount_paid] = useState("0");
  const [myTotal, setMyTotal] = useState("0");

  const fetchSalesData = async () => {
    setLoading(true);
    setloading_real(true);
    try {
      // Simulate API call
      const response = await getCashierOrders_reciept();
      // const response = { data: mockTransactions }
      console.log({ response });

      // Fetch staff data
      // await fetchStaffData()
      console.log(response.data);

      setMyBalance_due(response.data.balance_due);
      setMyAmount_paid(response.data.amount_paid);
      setMyTotal(response.data.mytotal);

      setTransactions(response.data.orders);

      // Calculate stats from actual data

      if (response.data) {
        const totalSales = response.data.orders?.reduce(
          (sum, txn) => sum + Number.parseFloat(txn?.payable_amount),
          0
        );
        const completedOrders = response.data.orders?.filter(
          (txn) => txn.order_status === "COMPLETED"
        )?.length;
        const pendingOrders = response.data.orders?.filter(
          (txn) => txn.order_status === "PENDING"
        )?.length;
    setloading_real(false);

        setSalesStats({
          total_sales: totalSales,
          total_orders: response.data.orders?.length,
          average_order_value: totalSales / response.data.orders?.length,
          top_payment_method: "cash",
          growth_percentage: 12.5,
          pending_orders: pendingOrders,
          completed_orders: completedOrders,
        });
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    } finally {
      setLoading(false);
          setloading_real(false);

    }
  };


    const fetchSalesData_date = async (start,end) => {
      console.log(start, end)
    setLoading(true);

    try {
      // Simulate API call
      const response = await getCashierOrders_reciept_date(start,end);
      // const response = { data: mockTransactions }
      console.log({ response });

      // Fetch staff data
      // await fetchStaffData()
      console.log(response.data);

      setMyBalance_due(response.data.balance_due);
      setMyAmount_paid(response.data.amount_paid);
      setMyTotal(response.data.mytotal);

      setTransactions(response.data.orders);

      // Calculate stats from actual data

      if (response.data) {
        const totalSales = response.data.orders?.reduce(
          (sum, txn) => sum + Number.parseFloat(txn?.payable_amount),
          0
        );
        const completedOrders = response.data.orders?.filter(
          (txn) => txn.order_status === "COMPLETED"
        )?.length;
        const pendingOrders = response.data.orders?.filter(
          (txn) => txn.order_status === "PENDING"
        )?.length;

        setSalesStats({
          total_sales: totalSales,
          total_orders: response.data.orders?.length,
          average_order_value: totalSales / response.data.orders?.length,
          top_payment_method: "cash",
          growth_percentage: 12.5,
          pending_orders: pendingOrders,
          completed_orders: completedOrders,
        });
      }
    } catch (error) {
      console.error("Error fetching sales data:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = transactions;

    // Apply search filter
    if (searchQuery) {
  const q = searchQuery.toLowerCase();
  filtered = filtered?.filter((transaction) =>
    (transaction?.order_code || "").toLowerCase().includes(q) ||
    (transaction?.firstName || "").toLowerCase().includes(q) ||
    (transaction?.order_id || "").toLowerCase().includes(q)
  );
}
    // if (searchQuery) {
    //   filtered = filtered?.filter(
    //     (transaction) =>
    //       transaction.order_code
    //         .toLowerCase()
    //         .includes(searchQuery.toLowerCase()) ||
    //       transaction.member_name
    //         .toLowerCase()
    //         .includes(searchQuery.toLowerCase()) ||
    //       transaction.order_id.toLowerCase().includes(searchQuery.toLowerCase())
    //   );
    // }



    if (filters?.startDate && filters?.endDate) {
      const start = new Date(filters?.startDate);
      start.setHours(0, 0, 0, 0); // 00:00:00

      const end = new Date(filters.endDate);
      end.setHours(23, 59, 59, 999); // 23:59:59.999

      filtered = filtered?.filter((transaction) => {
        const transactionDate = new Date(transaction.order_date);
        return transactionDate >= start && transactionDate <= end;
      });
    }

    // Apply payment method filter
    if (filters?.paymentMethod && filters?.paymentMethod !== "All") {
      filtered = filtered?.filter(
        (transaction) => transaction.mode_of_payment === filters?.paymentMethod
      );
    }

    // Apply order status filter
    if (filters.orderStatus && filters.orderStatus !== "All") {
      filtered = filtered?.filter(
        (transaction) => transaction.order_status === filters.orderStatus
      );
    }

    // Apply payment status filter
    if (filters?.paymentStatus && filters?.paymentStatus !== "All") {
      filtered = filtered?.filter(
        (transaction) => transaction?.payment_status === filters?.paymentStatus
      );
    }

    setFilteredTransactions(filtered);
  };

  const handleFilterChange = (field: keyof FilterState, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const clearFilters = () => {
    setFilters({
      startDate: dayjs(), // today
      endDate: dayjs(),
      paymentMethod: "",
      department: "",
      orderStatus: "",
      paymentStatus: "",
    });
    setSearchQuery("");
  };

  const viewTransactionDetail = (transaction: SalesTransaction) => {
    setSelectedTransaction(transaction);
    setShowTransactionDetail(true);
  };

  const toggleRowExpansion = (orderId: string) => {
    setExpandedRows((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId]
    );
  };

  const getOrderStatusColor = (status: string) => {
    switch (status?.toUpperCase()) {
      case "COMPLETED":
        return "success";
      case "PENDING":
        return "warning";
      case "CANCELLED":
        return "error";
      default:
        return "default";
    }
  };

  const getPaymentStatusLabel = (status: string) => {
    switch (status) {
      case "0":
        return "Unpaid";
      case "1":
        return "Paid";
      case "2":
        return "Partial";
      default:
        return "Unknown";
    }
  };

  const getPaymentStatusColor = (status: string) => {
    switch (status) {
      case "0":
        return "error";
      case "1":
        return "success";
      case "2":
        return "warning";
      default:
        return "default";
    }
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-NG", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const exportData = () => {
    // Create CSV content
    const headers = [
      "Order Code",
      "Date",
      "Member Name",
      "Payment Method",
      "Amount",
      "Balance Due",
      "Order Status",
      "Payment Status",
      "Items Count",
    ];

    const csvContent = [
      headers.join(","),
      ...filteredTransactions.map((transaction) =>
        [
          transaction.order_code,
          transaction.order_date,
          `"${transaction.member_name}"`,
          transaction.mode_of_payment,
          transaction.payable_amount,
          transaction.balance_due,
          transaction.order_status,
          getPaymentStatusLabel(transaction.payment_status),
          transaction.items.length,
        ].join(",")
      ),
    ].join("\n");

    // Download CSV
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `sales-report-${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleContraClick = () => {
    console.log("Contra Sales clicked");
    // Add your logic here

    fetchContraData();
  };

  const paymentMethodTotals = filteredTransactions.reduce(
    (acc, transaction) => {
      const { mode_of_payment, amount_paid } = transaction;
      if (!acc[mode_of_payment]) {
        acc[mode_of_payment] = 0;
      }
      acc[mode_of_payment] += Number(amount_paid);
      return acc;
    },
    {}
  );

  useIonViewWillEnter(() => {
    fetchSalesData();
    fetchContraData();
  });

const [startDatex, setStartDatex] = useState<Date | null>(null);
  const [endDatex, setEndDatex] = useState<Date | null>(null);;
const formatDateYMD = (date) => {
  return date.toISOString().slice(0, 10); // 'YYYY-MM-DD'
};
   
const liveFilter = ({ startDate, endDate }) => {
   const formattedStart = formatDateYMD(startDate);
  const formattedEnd = formatDateYMD(endDate); 
 // console.log("Date range: ", formattedStart );
 // console.log("Date range: ", formattedEnd );

  fetchSalesData_date(formattedStart,formattedEnd);
}; 
  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar>  <MenuButton/>
          <IonTitle>Sales Reciept</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonRefresher
          slot="fixed"
          onIonRefresh={(e) => {
            fetchSalesData().finally(() => e.detail.complete());
          }}
        >
          <IonRefresherContent />
        </IonRefresher>

        <Box sx={{ p: 2 }}>
          {/* Sales Statistics Cards */}
          {salesStats && (
            <Grid container spacing={2} sx={{ mb: 3 }}>
              {/* <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "primary.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <AttachMoney sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Sales
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      {formatCurrencyN(salesStats.total_sales)}
                    </Typography>
                    
                  </CardContent>
                  
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "success.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Receipt sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Orders
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      {salesStats.total_orders}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "warning.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Warning sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Pending Orders
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      {salesStats.pending_orders}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "info.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <CheckCircle sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Completed
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      {salesStats.completed_orders}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid> */}

             <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "primary.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <AttachMoney sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Sold Amount
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", fontSize: "1.2rem" }}
                    >
                      {formatCurrencyN(Number(myTotal))}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid> 
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "success.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Receipt sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Paid Amount{" "}
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", fontSize: "1.2rem" }}
                    >
                      {formatCurrencyN(Number(myAmount_paid))}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "warning.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Warning sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Unpaid Amount
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", fontSize: "1.2rem" }}
                    >
                      {formatCurrencyN(Number(myBalance_due))}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "info.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <CheckCircle sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Orders
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", fontSize: "1.2rem" }}
                    >
                      {salesStats.total_orders}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
          {/* <Button
    variant="contained"
    size="small"
    onClick={handleContraClick} // replace with your function
    sx={{
      bgcolor: "white",
      color: "primary.main",
      fontWeight: 600,
      textTransform: "none",
      borderRadius: 2,
      px: 2,
      "&:hover": {
        bgcolor: "grey.100",
      },
    }}
  >
    Contra My Sales
  </Button> */}

         
          {/* Search and Filter Controls */}
          <Paper sx={{ p: 2, mb: 2 }}>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
              <TextField
                fullWidth
                placeholder="Search by order code, customer name, or order ID..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <Search sx={{ mr: 1, color: "text.secondary" }} />
                  ),
                }}
                size="small"
              />
              <Button
                variant="outlined"
                startIcon={<FilterList />}
                onClick={() => setShowFilters(!showFilters)}
              >
                Filters
              </Button>
              <Button
                variant="outlined"
                startIcon={<Download />}
                onClick={exportData}
              >
                Export
              </Button>
            </Box>
            <Typography variant="body2" color="text.warning" sx={{ mb: 2 }}>
Select Date and wait for few moments to load the data 
            </Typography>
            {/* Filter Panel 
            
            showFilters (replace wit 1  to hide filter)*/}
            {1 && (
              <Box sx={{ borderTop: 1, borderColor: "divider", pt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={2}>
                    <DatePicker
                      label="Start Date"
                      value={filters.startDate}
 onChange={(date) => {
  handleFilterChange("startDate", date);
  setStartDatex(date);
  liveFilter({ startDate: date, endDate: filters.endDate });
}}
                      // renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <DatePicker
                      label="End Date"
                      value={filters.endDate}
                    onChange={(date) => {
  handleFilterChange("endDate", date);
  setEndDatex(date);
   liveFilter({  startDate: filters.startDate,endDate: date });

}}
                      // renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Payment Method</InputLabel>
                      <Select
                        value={filters.paymentMethod}
                        label="Payment Method"
                        onChange={(e) =>
                          handleFilterChange("paymentMethod", e.target.value)
                        }
                      >
                        {paymentMethods.map((method) => (
                          <MenuItem
                            key={method}
                            value={method === "All" ? "" : method}
                          >
                            {method}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {/* <Grid item xs={12} md={2}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Order Status</InputLabel>
                      <Select
                        value={filters.orderStatus}
                        label="Order Status"
                        onChange={(e) => handleFilterChange("orderStatus", e.target.value)}
                      >
                        {orderStatuses.map((status) => (
                          <MenuItem key={status} value={status === "All" ? "" : status}>
                            {status}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid> */}
                  {/* <Grid item xs={12} md={2}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Payment Status</InputLabel>
                      <Select
                        value={filters.paymentStatus}
                        label="Payment Status"
                        onChange={(e) => handleFilterChange("paymentStatus", e.target.value)}
                      >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="0">Unpaid</MenuItem>
                        <MenuItem value="1">Paid</MenuItem>
                        <MenuItem value="2">Partial</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid> */}
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={clearFilters}
                      fullWidth
                    >
                      Clear Filters
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Paper>

          {/* Results Summary */}
          <Alert severity="info" sx={{ mb: 2 }}>
            Showing {filteredTransactions?.length} of {transactions?.length}{" "}
            orders
          </Alert>

          {/* Transactions Table */}
          <TableContainer
            component={Paper}
            sx={{
              overflowX: "auto",
              "&::-webkit-scrollbar": {
                height: 8,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
                borderRadius: 4,
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#c1c1c1",
                borderRadius: 4,
                "&:hover": {
                  backgroundColor: "#a8a8a8",
                },
              },
            }}
          >
            <Table sx={{ minWidth: 1200 }}>
              <TableHead>
                <TableRow sx={{ bgcolor: "grey.100" }}>
                  <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>
                    Order Code
                  </TableCell>
                  <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>
                    Date
                  </TableCell>
                  <TableCell sx={{ minWidth: 200, whiteSpace: "nowrap" }}>
                    Customer
                  </TableCell>
                  <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                    Payment Method
                  </TableCell>
                  <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                   Outstanding Balance
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ minWidth: 120, whiteSpace: "nowrap" }}
                  >
                    Amount
                  </TableCell>
                  {/* <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                    Balance Due
                  </TableCell> */}
                  {/* <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Order Status</TableCell> */}
                  {/* <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Payment Status</TableCell> */}
                  <TableCell sx={{ minWidth: 100, whiteSpace: "nowrap" }}>
                    Items
                  </TableCell>
                  {/* <TableCell align="center" sx={{ minWidth: 100, whiteSpace: "nowrap" }}>
                    Actions
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading_real ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredTransactions?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                      <Typography variant="body1" color="text.secondary">
                        No orders found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  <React.Fragment>
                    {filteredTransactions
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((transaction) => {
                        const isExpanded = expandedRows.includes(
                          transaction.order_id
                        );
                        return (
                          <React.Fragment key={transaction.order_code}>
                            <TableRow
                              sx={{
                                "&:nth-of-type(even)": { bgcolor: "grey.50" },
                                "&:hover": { bgcolor: "action.hover" },
                              }}
                            >
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "primary.main",
                                  }}
                                >
                                  {transaction.order_code.toUpperCase()}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Typography variant="body2">
                                  {formatDate(transaction.order_date)}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <Person
                                    sx={{
                                      mr: 1,
                                      fontSize: 16,
                                      color: "text.secondary",
                                    }}
                                  />
                                  <Typography variant="body2">
                                    {transaction.firstName}
                                  </Typography>
                                </Box>
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Chip
                                  label={transaction.mode_of_payment}
                                  size="small"
                                  color="secondary"
                                />
                              </TableCell>


                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Chip
                                  label={transaction.balance_due}
                                  size="small"
                                  color="warning"
                                />
                              </TableCell>


                              <TableCell
                                align="right"
                                sx={{ whiteSpace: "nowrap" }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: "bold" }}
                                >
                                  {formatCurrencyN(
                                    Number(transaction.amount_paid)
                                  )}
                                </Typography>
                              </TableCell>
                              {/* <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: "bold",
                                  color: Number.parseFloat(transaction.balance_due) > 0 ? "error.main" : "success.main",
                                }}
                              >
                                {formatCurrencyN(transaction.balance_due)}
                              </Typography>
                            </TableCell> */}
                              {/* <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Chip
                                label={transaction.order_status}
                                size="small"
                                color={getOrderStatusColor(transaction.order_status) as any}
                              />
                            </TableCell> */}
                              {/* <TableCell sx={{ whiteSpace: "nowrap" }}>
                              <Chip
                                label={getPaymentStatusLabel(transaction.payment_status)}
                                size="small"
                                color={getPaymentStatusColor(transaction.payment_status) as any}
                              />
                            </TableCell> */}
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Button
                                  size="small"
                                  startIcon={
                                    isExpanded ? <ExpandLess /> : <ExpandMore />
                                  }
                                  onClick={() =>
                                    toggleRowExpansion(transaction.order_id)
                                  }
                                >
                                  {transaction.items.length} items
                                </Button>
                              </TableCell>
                              {/* <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                              <Tooltip title="View Details">
                                <IconButton
                                  size="small"
                                  onClick={() => viewTransactionDetail(transaction)}
                                  color="primary"
                                >
                                  <Visibility fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </TableCell> */}
                            </TableRow>

                            {/* Expandable Items Row */}
                            <TableRow>
                              <TableCell
                                style={{ paddingBottom: 0, paddingTop: 0 }}
                                colSpan={10}
                              >
                                <Collapse
                                  in={isExpanded}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <Box sx={{ margin: 1 }}>
                                    <Typography
                                      variant="h6"
                                      gutterBottom
                                      component="div"
                                    >
                                      Order Items
                                    </Typography>
                                    <Table size="small">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>Product</TableCell>
                                          <TableCell align="right">
                                            Quantity
                                          </TableCell>
                                          <TableCell align="right">
                                            Unit Price
                                          </TableCell>
                                          <TableCell align="right">
                                            Total
                                          </TableCell>
                                          <TableCell>Status</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {transaction.items.map(
                                          (item, index) => (
                                            <TableRow
                                              key={`${transaction.order_id}-${index}`}
                                            >
                                              <TableCell>
                                                {item.product_name}
                                              </TableCell>
                                              <TableCell align="right">
                                                {item.quantity}
                                              </TableCell>
                                              <TableCell align="right">
                                                {formatCurrencyN(item.price)}
                                              </TableCell>
                                              <TableCell align="right">
                                                {formatCurrencyN(
                                                  item.total_amount
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                <Chip
                                                  label={item.item_status}
                                                  size="small"
                                                  color={
                                                    getOrderStatusColor(
                                                      item.item_status
                                                    ) as any
                                                  }
                                                />
                                              </TableCell>
                                            </TableRow>
                                          )
                                        )}
                                      </TableBody>
                                    </Table>
                                  </Box>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    {filteredTransactions?.length > 0 && (
                      <>
                        <TableRow sx={{ backgroundColor: "grey.100" }}>
                          <TableCell colSpan={4} align="right">
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: "bold" }}
                            >
                              Page Total
                            </Typography>
                          </TableCell>
                          <TableCell align="right">
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: "bold" }}
                            >
                              {formatCurrencyN(
                                filteredTransactions
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .reduce(
                                    (sum, tx) =>
                                      sum + parseFloat(tx.amount_paid || "0"),
                                    0
                                  )
                              )}
                            </Typography>
                          </TableCell>
                          <TableCell colSpan={1} align="right">
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: "bold" }}
                            ></Typography>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: "grey.200" }}>
                          <TableCell colSpan={4} align="right">
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: "bold" }}
                            >
                              Grand Total
                            </Typography>
                          </TableCell>

                          <TableCell align="right">
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: "bold" }}
                            >
                              {formatCurrencyN(
                                filteredTransactions.reduce(
                                  (sum, tx) =>
                                    sum + parseFloat(tx.amount_paid || "0"),
                                  0
                                )
                              )}
                            </Typography>
                          </TableCell>

                          <TableCell colSpan={1} align="right">
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: "bold" }}
                            ></Typography>
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </React.Fragment>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 500, 1000]}
              component="div"
              count={filteredTransactions?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(_, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(Number.parseInt(e.target.value, 40));
                setPage(0);
              }}
            />
          </TableContainer>

        </Box>

        {/* Transaction Detail Modal */}
        <Dialog
          open={showTransactionDetail}
          onClose={() => setShowTransactionDetail(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            Order Details - {selectedTransaction?.order_code}
            <IconButton
              sx={{ position: "absolute", right: 8, top: 8 }}
              onClick={() => setShowTransactionDetail(false)}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {selectedTransaction && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>
                    Order Information
                  </Typography>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Order Code
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {selectedTransaction.order_code.toUpperCase()}
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Order ID
                    </Typography>
                    <Typography variant="body1">
                      {selectedTransaction.order_id}
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Date & Time
                    </Typography>
                    <Typography variant="body1">
                      {formatDate(selectedTransaction.order_date)}
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Order Status
                    </Typography>
                    <Chip
                      label={selectedTransaction.order_status}
                      color={
                        getOrderStatusColor(
                          selectedTransaction.order_status
                        ) as any
                      }
                      sx={{ mt: 0.5 }}
                    />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Staff
                    </Typography>
                    <Typography variant="body1">
                      {selectedTransaction.order_by}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>
                    Member & Payment
                  </Typography>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Member Name
                    </Typography>
                    <Typography variant="body1">
                      {selectedTransaction.member_name}
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Tab Balance
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {formatCurrencyN(selectedTransaction.tabBalance)}
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Debt Balance
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        color:
                          selectedTransaction.debtBalance > 0
                            ? "error.main"
                            : "success.main",
                      }}
                    >
                      {formatCurrencyN(selectedTransaction.debtBalance)}
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Wallet Details
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {formatCurrencyN(selectedTransaction.walletDetails)}
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Wallet Details (L)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {formatCurrencyN(selectedTransaction.walletDetails_l)}
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Payment Method
                    </Typography>
                    <Chip
                      label={selectedTransaction.mode_of_payment}
                      color="secondary"
                      sx={{ mt: 0.5 }}
                    />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Payment Status
                    </Typography>
                    <Chip
                      label={getPaymentStatusLabel(
                        selectedTransaction.payment_status
                      )}
                      color={
                        getPaymentStatusColor(
                          selectedTransaction.payment_status
                        ) as any
                      }
                      sx={{ mt: 0.5 }}
                    />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Total Amount
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", color: "primary.main" }}
                    >
                      {formatCurrencyN(selectedTransaction.payable_amount)}
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Balance Due
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color:
                          Number.parseFloat(selectedTransaction.balance_due) > 0
                            ? "error.main"
                            : "success.main",
                      }}
                    >
                      {formatCurrencyN(selectedTransaction.balance_due)}
                    </Typography>
                  </Box>

                  {/* Add the new fields here */}
                </Grid>

                <Grid item xs={12}>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    Order Items ({selectedTransaction.items.length})
                  </Typography>
                  <List>
                    {selectedTransaction.items.map((item, index) => (
                      <ListItem key={index} divider>
                        <ListItemText
                          primary={
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Typography variant="subtitle1">
                                {item.product_name}
                              </Typography>
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "bold" }}
                              >
                                {formatCurrencyN(item.total_amount)}
                              </Typography>
                            </Box>
                          }
                          secondary={
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: 1,
                              }}
                            >
                              <Typography variant="body2">
                                Qty: {item.quantity} ×{" "}
                                {formatCurrencyN(item.price)}
                              </Typography>
                              <Chip
                                label={item.item_status}
                                size="small"
                                color={
                                  getOrderStatusColor(item.item_status) as any
                                }
                              />
                            </Box>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowTransactionDetail(false)}>
              Close
            </Button>
            <Button variant="contained" startIcon={<Download />}>
              Download Receipt
            </Button>
          </DialogActions>
        </Dialog>
      </IonContent>
    </IonPage>
  );
};

export default SalesRecieptPage_Ex;
